export const GET_PARTIES = "GET_PARTIES";
export const GET_PARTY = "GET_PARTY";
export const ADD_PARTY = "ADD_PARTY";
export const DELETE_PARTY = "DELETE_PARTY";
export const UPDATE_PARTY = "UPDATE_PARTY";
